<template>
  <div class="footer">
    <div class="footer_content">
      <div class="scroll-down header_click" data-id="body"></div>
      <div class="footer-azour-container">
        <h1 class="brand">{{restaurant.name}}</h1>
        <span class="brand-text">Restaurant & lounge</span>
        <span class="onomo"></span>
        <span class="onomo-text">Hotels</span>
        <span class="social-azour">SHARE WITH US #{{restaurant.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["restaurant", "currentLang"],

  data() {
    return {};
  },
  methods: {},
  watch: {},
};
</script>
<style>
.footer {
  width: 100%;
  /* max-width: 780px; */
  height: 103vh;
  background-image: url(htttp://localhost:3333/azour/img/background.jpg);
  padding: 12px;
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  position: relative;
}
.footer_content {
  width: 100%;
  /* max-width: 780px; */
  background-color: black;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
.scroll-down::before,
.scroll-down::after {
  content: "";
  position: absolute;
  top: 20%;
  left: 50%;
  height: 10px;
  width: 10px;
  transform: translate(-50%, -100%) rotate(45deg);
  border: 2px solid #fff;
  border-top: transparent;
  border-left: transparent;
  animation: scroll-down 1s ease-in-out infinite;
  outline: unset !important;
}
.scroll-down::before {
  top: 30%;
  animation-delay: 0.3s;
  /* animation: scroll-down 1s ease-in-out infinite; */
}
@keyframes scroll-down {
  0% {
    /* top:20%; */
    opacity: 0;
  }
  30% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  100% {
    top: 90%;
    opacity: 0;
  }
}

.footer .scroll-down {
  position: absolute;
  height: 50px;
  width: 30px;
  border: 2px solid #fff;
  left: 48%;
  top: 20%;
  border-radius: 50px;
  cursor: pointer;
  outline: unset !important;
  transform: rotate(180deg);
}

.brand {
  color: #e6a0da;
  font-size: 70px;
  font-family: sans-serif;
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: 12px;
  /* font-family: 'Major Mono Display', monospace; */
  font-family: "Major Mono Display", monospace;
}
.brand-text {
  color: #fff;
  letter-spacing: 4px;
  font-size: 20px;
  text-transform: uppercase;
  margin-bottom: 12px;
}
.onomo {
  color: orange;
  font-weight: bolder;
  font-size: 30px;
  text-transform: uppercase;
  margin-bottom: 12px;
}
.onomo-text {
  color: orange;
  text-transform: uppercase;
  letter-spacing: 3px;
  font-size: 16px;
  font-weight: 100px;
  margin-bottom: 36px;
}
.social-azour {
  color: #fff;
  margin-bottom: 50px;
}
.footer-azour-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
